module.exports = __webpack_public_path__ + "static/media/How to apply.2b8287be.jpg";